import { render, staticRenderFns } from "./ApproveArticleDetail.vue?vue&type=template&id=90a0c0b4&scoped=true&"
import script from "./ApproveArticleDetail.vue?vue&type=script&lang=js&"
export * from "./ApproveArticleDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApproveArticleDetail.vue?vue&type=style&index=0&id=90a0c0b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a0c0b4",
  null
  
)

export default component.exports